var exports = {
  "kL": "xdbfd91f1--f4b8e4--container",
  "_r": "xdbfd91f1--f4b8e4--text_container",
  "h_": "xdbfd91f1--f4b8e4--description",
  "gJ": "xdbfd91f1--f4b8e4--fade_out",
  "V8": "xdbfd91f1--f4b8e4--fade_out--vertical_shadow",
  "m8": "xdbfd91f1--f4b8e4--show_more",
  "Y": "xdbfd91f1--f4b8e4--more_text",
};

module.exports = exports;
